import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterCacheService {
  private storage = window.sessionStorage;

  setFilters<T>(moduleKey: string, filters: T): void {
    this.storage.setItem(`filters_${moduleKey}`, JSON.stringify(filters));
  }

  getFilters<T>(moduleKey: string): T | null {
    const data = this.storage.getItem(`filters_${moduleKey}`);
    return data ? JSON.parse(data) : null;
  }

  clearFilters(moduleKey: string): void {
    this.storage.removeItem(`filters_${moduleKey}`);
  }
}
